import axiosInstance from "../../utils/axiosInstance";

const getJackpots = async (params) => {
  console.log(params);
  const response = await axiosInstance.get(`jackpot?limit=${params.pageSize}&skip=${(params.current - 1) * params.pageSize}&key=${params.key}&status=${params.status}&type=${params.type}`);
  return response.data.data;
};

const getJackpot = async (id) => {
  const response = await axiosInstance.get(`jackpot/${id}`);
  return response.data.data;
};

const createJackpot = async (data) => {
  const response = await axiosInstance.post(`jackpot`, data);
  return response.data.data;
};

const updateJackpot = async (params) => {
  const response = await axiosInstance.put(`jackpot/${params.id}`, params.data);
  return response.data.data;
};

const deleteJackpot = async (params) => {
  const response = await axiosInstance.delete(`jackpot/${params.id}`);
  return response.data.data;
};

const refreshJackpot = async (data) => {
  const response = await axiosInstance.post(`jackpot/refresh`, data);
  return response.data.data;
};

const updateJackpotStatus = async (params) => {
  const response = await axiosInstance.put(`jackpot/${params.id}`, params.data);
  return response.data.data;
};

const getJackpotEntries = async (params) => {
  const response = await axiosInstance.get(`jackpot/entries?limit=${params.pageSize}&skip=${(params.current - 1) * params.pageSize}&status=${params.status}&type=${params.type}&key=${params.key}`);
  return response.data.data;
};

const approvedJackpotEntry = async (params) => {
  const response = await axiosInstance.post(`jackpot/entries/approve`, params);
  return response.data.data;
};

const rejectJackpotEntry = async (params) => {
  const response = await axiosInstance.post(`jackpot/entries/reject`, params);
  return response.data.data;
};

const getJackpotEntry = async (id) => {
  const response = await axiosInstance.get(`jackpot/entries/${id}`);
  return response.data.data;
};

const updateJackpotEntry = async (data) => {
  const response = await axiosInstance.put(`jackpot/entries/${data.id}`, data.data);
  return response.data.data;
};

const addToFeedJackpotEntry = async (params) => {
  const response = await axiosInstance.post(`jackpot/entries/add-to-feed`, params);
  return response.data.data;
};

const removeFromFeedJackpotEntry = async (params) => {
  const response = await axiosInstance.post(`jackpot/entries/remove-from-feed`, params);
  return response.data.data;
};


const jackpotService = {
  getJackpots,
  updateJackpot,
  createJackpot,
  updateJackpotStatus,
  getJackpot,
  deleteJackpot,
  refreshJackpot,
  getJackpotEntries,
  approvedJackpotEntry,
  rejectJackpotEntry,
  getJackpotEntry,
  updateJackpotEntry,
  addToFeedJackpotEntry,
  removeFromFeedJackpotEntry,
};

export default jackpotService;
